/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Category_Getting_StartedInputs */

const en_blog_category_getting_started = /** @type {(inputs: Blog_Category_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started`)
};

const lv_blog_category_getting_started = /** @type {(inputs: Blog_Category_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā sākt`)
};

/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Blog_Category_Getting_StartedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_category_getting_started = /** @type {((inputs?: Blog_Category_Getting_StartedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Category_Getting_StartedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_category_getting_started(inputs)
	return en_blog_category_getting_started(inputs)
});